export default __webpack_public_path__ + "static/media/cryptoo.2cc62fab.png";